import React from 'react';
import { useDroppable } from '@dnd-kit/core';
import { SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable';
import PipelineCard from './PipelineCard';

/**
 * Column color configurations
 */
const COLUMN_COLORS = {
  pendientes: {
    bg: 'bg-orange-50',
    border: 'border-orange-300',
    text: 'text-orange-700',
    dot: 'bg-orange-500',
  },
  en_proceso: {
    bg: 'bg-yellow-50',
    border: 'border-yellow-300',
    text: 'text-yellow-700',
    dot: 'bg-yellow-500',
  },
  emitidas_sin_pagar: {
    bg: 'bg-blue-50',
    border: 'border-blue-300',
    text: 'text-blue-700',
    dot: 'bg-blue-500',
  },
  pagadas: {
    bg: 'bg-green-50',
    border: 'border-green-300',
    text: 'text-green-700',
    dot: 'bg-green-500',
  },
};

/**
 * PipelineColumn - A droppable column in the pipeline kanban
 */
const PipelineColumn = ({ columnId, title, subtitle, items, onCardClick, onDiferir, onReactivar, onEditEnProceso }) => {
  const { setNodeRef, isOver } = useDroppable({
    id: columnId,
  });

  const colors = COLUMN_COLORS[columnId] || COLUMN_COLORS.pendientes;
  const itemIds = items.map(item => item.id);

  return (
    <div
      className={`flex flex-col w-72 min-w-[288px] bg-zinc-50 rounded-xl border transition-all ${
        isOver ? 'border-azul-surelia ring-2 ring-azul-surelia/20' : 'border-zinc-200'
      }`}
    >
      {/* Column Header */}
      <div className={`flex items-center gap-2 p-3 rounded-t-xl ${colors.bg}`}>
        <span className={`w-2.5 h-2.5 rounded-full ${colors.dot}`} />
        <div className="flex-1">
          <span className={`font-medium text-sm ${colors.text}`}>{title}</span>
          {subtitle && (
            <span className={`block text-xs ${colors.text} opacity-70`}>{subtitle}</span>
          )}
        </div>
        <span className={`text-xs px-2 py-0.5 rounded-full bg-white/60 font-medium ${colors.text}`}>
          {items.length}
        </span>
      </div>

      {/* Cards Container */}
      <div
        ref={setNodeRef}
        className="flex-1 p-2 space-y-2 overflow-y-auto max-h-[calc(100vh-320px)] min-h-[150px]"
      >
        <SortableContext items={itemIds} strategy={verticalListSortingStrategy}>
          {items.map((item) => (
            <PipelineCard
              key={item.id}
              item={item}
              onClick={() => onCardClick?.(item)}
              onDiferir={onDiferir}
              onReactivar={onReactivar}
              onEditEnProceso={onEditEnProceso}
            />
          ))}
        </SortableContext>

        {items.length === 0 && (
          <div className="flex flex-col items-center justify-center py-8 text-center">
            <p className="text-sm text-zinc-400">Sin fianzas</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default PipelineColumn;
